import { Box, Stack, styled } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const TimeKeepingWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  gap: pxToRem(12),
  margin: `${pxToRem(24)} ${pxToRem(20)}`,
}));

export const Header = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  [theme.breakpoints.down("md")]: {
    gap: pxToRem(24),
    justifyContent: "center",
  },
}));

export const TableWrapper = styled(Box)(({ theme }) => ({
  table: {
    thead: {
      tr: {
        th: {
          div: {
            justifyContent: "center",
          },
        },
      },
    },
  },
}));
